"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _cookies = require("@kiwicom/cookies");
var _Currency = require("../../records/Currency");
var _getGeoCountry = _interopRequireDefault(require("./services/getGeoCountry"));
var _init = _interopRequireDefault(require("../../services/currency/init"));
var _getAll = _interopRequireDefault(require("../../services/currency/getAll"));
var _rewriteCurrencies = _interopRequireDefault(require("../../services/currency/services/rewriteCurrencies"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// would require too much 'Currencies' type refactoring, so not done immediately
class CurrencyProvider extends React.PureComponent {
  constructor(props) {
    super(props);
    (0, _defineProperty2.default)(this, "handleChange", code => {
      const {
        available
      } = this.state;
      const {
        onChange
      } = this.props;
      (0, _cookies.save)(_cookies.Cookie.CURRENCY, code);
      const currency = available[code];
      if (currency) {
        this.setState({
          currency
        });
        onChange(code);
      }
    });
    this.state = {
      currency: null,
      loading: false,
      all: {},
      available: {},
      recommended: [],
      country: ""
    };
  }
  static getDerivedStateFromProps(props, state) {
    var _props$countries$stat;
    if (state.currency !== null) {
      return null;
    }
    if (!state.all || !state.country) {
      return null;
    }
    const countryCurrency = (_props$countries$stat = props.countries[state.country]) === null || _props$countries$stat === void 0 ? void 0 : _props$countries$stat.currency;
    const languageCurrency = props.langCurrency;
    const config = {
      currencies: state.all,
      countryCurrency,
      languageCurrency,
      affiliate: props.affiliate,
      brandCurrencies: props.brand.payments.whitelisted_currencies,
      mostUsedCurrencies: props.mostUsed
    };
    const initialCurrency = (0, _cookies.load)(_cookies.Cookie.CURRENCY);
    if (initialCurrency != null) {
      config.initialCurrency = initialCurrency;
    }
    return (0, _init.default)(config);
  }
  componentDidMount() {
    this.loadData();
  }
  componentDidUpdate(props, state) {
    if (!state.all) {
      this.loadData();
    }
  }
  async loadData() {
    const {
      getCurrencies,
      getGeoCountry,
      ip,
      url
    } = this.props;
    this.setState({
      loading: true
    });
    const [all, country] = await Promise.all([getCurrencies({
      options: {
        url
      }
    }), getGeoCountry(ip)]);
    this.setState({
      loading: false,
      all: (0, _rewriteCurrencies.default)(all),
      country
    });
  }
  render() {
    const {
      currency,
      available,
      recommended
    } = this.state;
    const {
      children
    } = this.props;
    if (!currency) {
      return children({
        currency: _Currency.currencyDefault,
        available: {},
        recommended: [],
        onChange: () => {}
      });
    }
    return children({
      currency,
      available,
      recommended,
      onChange: this.handleChange
    });
  }
}
exports.default = CurrencyProvider;
(0, _defineProperty2.default)(CurrencyProvider, "defaultProps", {
  mostUsed: _Currency.MOST_USED_CURRENCIES,
  getCurrencies: _getAll.default,
  getGeoCountry: _getGeoCountry.default
});